import React from 'react';
import { View, StyleSheet } from 'react-native';
import { appColors } from '../../assets/styles/global';
import { pixelDimensions } from '../../config/utils';
import { AppText } from '../form';

const LineChart = ({ name, percentage, showValue = true }) => (
  <View style={styles.viewChart}>
    <AppText size="bold" style={styles.text}>{name}</AppText>
    <View style={styles.viewSuper}>
      <View style={styles.viewContainer}>
        <View style={[styles.viewLine, styles.viewBackLine]} />
        <View style={[styles.viewLine, styles.viewFrontLine, { width: `${percentage}%` }]} />
      </View>
      { showValue && <AppText style={[styles.text, styles.textPercentage]}>{`${percentage} %`}</AppText> }
    </View>
  </View>
);

const styles = StyleSheet.create({
  text: { fontSize: pixelDimensions(4) },
  textPercentage: { marginHorizontal: pixelDimensions(2) },
  viewBackLine: { opacity: 0.3, width: '100%' },
  viewChart: { marginVertical: pixelDimensions(1), width: pixelDimensions(45), height: pixelDimensions(11) },
  viewContainer: { flexDirection: 'row', flex: 1 },
  viewFrontLine: { opacity: 0.9, zIndex: 10 },
  viewLine: { position: 'absolute', height: pixelDimensions(5), backgroundColor: appColors.primary },
  viewSuper: { justifyContent: 'space-between', flexDirection: 'row' },
});

export default LineChart;
